import * as React from 'react'
import { connect } from 'react-redux'

import { Navbar as StudentLessonsNavbar } from '../../../navbar/studentLessonsNavbar'
import { getStoredEditionQuestions } from '../../../../reducers/combined'

interface SlidePreviewProps {
  children: React.ReactNode,
  slideNumber?: number,
  totalSlides?: number,
}

const LIVE_REGION_SELECTOR = '[aria-live], [role="status"], [role="alert"], [role="log"]'
const LIVE_ROLES = ['status', 'alert', 'log']

export const SlidePreview = ({ children, slideNumber, totalSlides }: SlidePreviewProps) => {
  const counterText = slideNumber && totalSlides ? `${slideNumber} of ${totalSlides}` : ''
  const previewRef = React.useRef<HTMLDivElement>(null)

  // `inert` alone doesn't stop screen readers announcing live regions, so strip
  // the live-region semantics from the reused student components in the preview.
  React.useLayoutEffect(() => {
    previewRef.current?.querySelectorAll(LIVE_REGION_SELECTOR).forEach((el) => {
      el.removeAttribute('aria-live')
      el.removeAttribute('aria-atomic')
      if (LIVE_ROLES.includes(el.getAttribute('role') || '')) {
        el.removeAttribute('role')
      }
    })
  }, [children])

  return (
    <div className="slide-preview-container">
      <h3 className="preview-label">Preview</h3>
      <div className="preview" inert ref={previewRef}>
        <div className="scaler">
          <div className="preview-page">
            <StudentLessonsNavbar counterText={counterText} />
            <div className="preview-page-body">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function select(state) {
  // minus the lobby slide
  const editionQuestions = getStoredEditionQuestions(state)
  const questions = editionQuestions && editionQuestions.questions
  return { totalSlides: questions ? questions.length - 1 : undefined }
}

export default connect(select)(SlidePreview)
